import { useEffect, useState } from 'react';
import { filter, finalize } from 'rxjs/operators';
import { IUserDetails } from '@vivli/features/users/infrastructure/interface';
import { useUsersApiContext } from '@vivli/core/infrastructure/context';

export function useVivliAdmins() {
    const [vivliAdmins, setVivliAdmins] = useState<IUserDetails[]>();
    const [isLoadingVivliAdmins, setIsLoadingVivliAdmins] = useState(false);

    const usersService = useUsersApiContext();

    useEffect(() => {
        setIsLoadingVivliAdmins(true);
        const usersSub = usersService
            .getVivliAdmins()
            .pipe(
                filter((users) => users !== null),
                finalize(() => setIsLoadingVivliAdmins(false))
            )
            .subscribe(setVivliAdmins);

        return () => {
            usersSub.unsubscribe();
        };
    }, []);

    return {
        vivliAdmins,
        isLoadingVivliAdmins,
    };
}
